import {IDatasetConfig, DatasetActionOpenType, ListViewItemTypes } from 'app/interfaces';
import {fieldsMap} from './fields';
import createForm from './forms/create.form';
import detailForm from './forms/detail.form';
import editForm from './forms/edit.form';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const beforeCallDetail = {
	name: 'record',
	path: '/dataset/entity_staff_element_unified_list_items/detail/:recordId',
	params: {
		with_relations: 'entityStaffElement'
	}
};

function getCallParams(dataContainerService: IDataContainerService, parentData: any, params: any): any{
	const tripResourceId = dataContainerService.getValueFromKeyPath('trip_resources.recordId');
	const actualTripId = dataContainerService.getValueFromKeyPath('actual_trips.recordId');
	if(tripResourceId){
		const listId = dataContainerService.getValueFromKeyPath('trip_resources.staff_list_id');
		if(listId){
			params.list_id = listId;
		}else{
			params['foreign_parent_record_id'] = tripResourceId;
			params['foreign_parent_dataset_code'] = 'trip_resources';
			params['foreign_parent_field_key'] = 'staff_list_id';
		}
	}else if(actualTripId){
		params['foreign_parent_record_id'] = actualTripId;
		params['foreign_parent_dataset_code'] = 'actual_trips';
		const listProperties = dataContainerService.getValueFromKeyPath('entity_staff_element_unified_list_items.filters.list_properties');
		if(listProperties) params['list_properties'] = JSON.stringify(listProperties);
		else console.log('no listproperties', dataContainerService);
	}
	if(params['list_properties'] && typeof(params['list_properties']) !== 'string'){
		params['list_properties'] = JSON.stringify(params['list_properties']);
	}

	params.with_relations = 'entityStaffElement';

	return params;
}

export const EntityStaffElementUnifiedListItemsConfig: IDatasetConfig = {
	name: 'entity_staff_element_unified_list_items',
	title: 'Staff',
	singleTitle: 'Staff',
	ajaxDatasetCode: 'entity_staff_element_unified_list_items',
	fieldsMap: fieldsMap,
	supportProperties: true,
	nestedProperties: ['entity_staff_elements'],
	enabledActions: {
		detail: true,
		create: true,
		edit: true,
		list: true
	},
	formConfigsMap: {
		createForm,
		detailForm,
		editForm
	},
	fetchConfig: {
		with_relations: 'entityStaffElement'
	},
	defaultActions: {
		detail: {
			openType: DatasetActionOpenType.DIALOG,
			beforeCalls: [ beforeCallDetail ],
			viewConfig: {
				formConfig: detailForm,
				actions: {
					edit: false,
					delete: false
				}
			}
		},
		create: {
			openType: DatasetActionOpenType.DIALOG,
			getCallParams,
			viewConfig: {
				formConfig: createForm
			}
		},
		edit: {
			openType: DatasetActionOpenType.DIALOG,
			getCallParams,
			viewConfig: {
				formConfig: editForm,
			},
		},
		list: {
			openType: DatasetActionOpenType.PAGE,
			getCallParams,
			viewConfig: {
				itemViewType: ListViewItemTypes.TABLE,
				showSearchBar: true,
				defaultSortBy: 'created_at',
				defaultSortDirection: 'asc',
				columns: [
					{
						title: 'Codice',
						key: 'entity_staff_element_code',
					},
					{
						title: 'Descrizione',
						key: 'entity_staff_element_description',
						fieldDefinition: fieldsMap.get('entity_staff_element_description')
					},
					{
						title: 'Tipologia',
						key: 'entity_staff_element_staff_type'
					},
				],
				actions: ['create', 'detail', 'edit', 'delete']
			}
		}
	}
};
